import { Component, Prop, Event, EventEmitter, Method, State, Element, h } from '@stencil/core';
import { Color, Size } from '../../interface';

@Component({
  tag: 'lar-push-button',
  styleUrl: 'push-button.scss',
  shadow: true
})
export class LarvaPushButton {
  @Element() el!: HTMLElement;

  /////// LarvaNode base properties
  /**
   * Component main icon
   */
  @Prop({ mutable: true }) icon?: string = 'security';
  /**
   * The color to use from your application's color palette.
   * Detrouble options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop({ mutable: true }) color?: Color = 'primary';
  /**
   * The color to use from your application's color palette for Components modal window.
   */
  @Prop({ mutable: true }) colorModal?: Color;
  /**
   * The color to use from your application's color palette for inputs
   */
  @Prop({ mutable: true }) colorInputs?: Color;
  /**
   * The color to use from your application's color palette for indication icon
   */
  @Prop() colorIconSmall?: Color;
  /**
   * Disable quck actions
   */
  @Prop() disableQuickActions: boolean = false;
  /**
   * Hide node titles
   */
  @Prop() hideTitles?: boolean;
  /**
   * Component superscript title
   */
  @Prop() supTitle?: string;
  /**
   * Component subtitle
   */
  @Prop() subTitle?: string;
  /**
   * Is logging for this component enabled (lar-log subcomponent loaded)
   */
  @Prop() log: boolean = false;
  /**
   * Component main title
   */
  @Prop() mainTitle!: string;
  /**
   * Node size
   */
  @Prop() nodeSize?: Size = 'default';
  /**
   * @see {@link ../readme.md} chapter "Components input and output" for further information.
   */
  @Event() output!: EventEmitter;
  /**
   * @see {@link ../readme.md} chapter "Sub-Components requests and responses" for further information.
   */
  @Event() request!: EventEmitter;
  /////// LarvaNode base properties and events - end

  @State() loading: boolean = false;
  private node!: HTMLLarNodeElement;

  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node') as HTMLLarNodeElement;
    // this.output.emit(); // push button doesnt have a state
  }

  /**
   * Larva error input
   */
  @Method()
  async error(data: any) {
    if (this.node) {
      this.node.error(data);
    }
    this.loading = false;
  }
  /**
   * Larva input message
   */
  @Method()
  async input(data: any) {
    this.loading = false;
  }

  private handleClick(data: boolean) {
    this.loading = true;
    this.output.emit(data);
  }

  render() {
    const componentProps = {
      onClick: () => this.handleClick(true),
      disabled: this.loading,
      color: this.colorInputs || this.color,
    };
    return [
      <lar-node
        icon={this.icon}
        hideTitles={this.hideTitles}
        color={this.color}
        supTitle={this.supTitle}
        mainTitle={this.mainTitle}
        subTitle={this.subTitle}
        colorModal={this.colorModal}
        colorInputs={this.colorInputs}
        colorIconSmall={this.colorIconSmall}
        loading={this.loading}
        log={this.log}
        nodeSize={this.nodeSize}
        component="lar-push-button-content"
        componentProps={componentProps}
      >
      {this.disableQuickActions === false &&
        <lar-button-push
          slot="titles"
          size="small"
          color={this.colorInputs || this.color}
          disabled={this.loading}
          onClick={ev => this.handleClick(true)}
        />
      }
      <slot />
      </lar-node>
    ];
  }
}
